/* Duskhaven recently viewed: display rules, 2026-10-14 (Todd, Duskhaven 4.9).
 * Loaded by sections/dh-recent.liquid next to assets/dh-recent.js, which draws the cards. This file only decides whether
 * the row is worth showing, so dh-recent.js stays as it is:
 *   - fewer cards than data-min (default 2) and the whole row stays hidden: one lonely card looks like a mistake;
 *   - on the cart page (data-exclude-cart="true") pieces already in the cart are left out, since the row is for the
 *     lamp the shopper is still weighing, not the one they already chose.
 * The empty cart drawer's compact row (data-variant="drawer") is left alone. Storage and network failures fall back
 * to showing the row as dh-recent.js drew it. */
(function () {
  'use strict';

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var href = a ? (a.getAttribute('href') || '') : '';
    var i = href.indexOf('/products/');
    if (i < 0) return '';
    try {
      return decodeURIComponent(href.slice(i + 10).split('?')[0].split('#')[0].split('/')[0]);
    } catch (e) {
      return '';
    }
  }

  function cartHandles() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (c) { return (c.items || []).map(function (item) { return item.handle; }); })
      .catch(function () { return []; });
  }

  function setup(el) {
    if (el._dhRules || el.dataset.variant === 'drawer') return;
    var body = el.querySelector('[data-dh-recent-body]');
    var list = el.querySelector('[data-dh-recent-list]');
    if (!body || !list) return;
    el._dhRules = true;
    var min = parseInt(el.dataset.min, 10);
    if (!(min >= 1)) min = 2;
    var inCart = el.dataset.excludeCart === 'true' ? cartHandles() : Promise.resolve([]);
    var busy = false;

    function apply() {
      if (busy || body.hidden) return;
      busy = true;
      body.style.visibility = 'hidden';
      inCart.then(function (handles) {
        Array.prototype.slice.call(list.children).forEach(function (card) {
          if (handles.indexOf(handleOf(card)) > -1) card.remove();
        });
        if (list.children.length < min) body.hidden = true;
        body.style.visibility = '';
        busy = false;
      });
    }

    new MutationObserver(apply).observe(body, { attributes: true, attributeFilter: ['hidden'] });
    apply();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('dh-recent')).forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
